import {
  FETCH_SURVEY_PENDING,
  FETCH_SURVEY_SUCCESS,
  FETCH_SURVEY_FAIL,
  FETCH_SURVEY_RESULT_PENDING,
  FETCH_SURVEY_RESULT_FAIL,
  SUBMIT_ANSWER_SUCCESS,
  SUBMIT_ANSWER_PENDING,
  SUBMIT_ANSWER_FAIL,
  GOTO_NEXT_QUESTION,
  GOTO_PREV_QUESTION,
  GOTO_QUESTION,
  SUBMIT_SURVEY_PENDING,
  SUBMIT_SURVEY_SUCCESS,
  SUBMIT_SURVEY_FAIL,
  RESET_APP,
  FETCH_SURVEY_RESULT_SUCCESS,
  GOTO_SUBMIT_PAGE,
  GOTO_SURVEY_PAGE,
} from '~/constants/action_types';

const defaultState = {
  surveyCode: null,
  id: null,
  status: null,
  pendingAnswers: 0,
  isLoading: false, // the survey itself is being loaded
  isSaving: false, // part of the survey is being saved (e.g., submitting an answer in-progress)
  isSubmitted: false, // the survey as-a-whole has been successfully submitted
  isSubmitting: false, // the survey as-a-whole has been submitted
  isExpired: false, // the survey has expired
  isPreview: false, // the survey has been launched from the admin app as a "preview", not a real survey
  showSubmitPage: false, // land user to submit page
  canViewResults: false,
  currentQuestionIndex: 0,
  error: '',
  submitError: '',
};

const surveyReducer = (state = defaultState, action) => {
  let pendingAnswers = 0;
  switch (action.type) {
    case GOTO_SUBMIT_PAGE:
      return {
        ...state,
        showSubmitPage: true,
      };
    case GOTO_SURVEY_PAGE:
      return {
        ...state,
        showSubmitPage: false,
      };
    case GOTO_QUESTION:
      return {
        ...state,
        currentQuestionIndex: action.currentQuestionIndex,
        showSubmitPage: false,
      };
    case FETCH_SURVEY_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SURVEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        surveyCode: action.surveyCode,
        id: action.id,
        name: action.name,
        status: action.status,
        isPreview: action.isPreview,
        canViewResults: action.canViewResults,
        companyId: action.companyId,
        showSubmitPage: action.showSubmitPage,
        isSubmitted: action.submitted,
        isExpired: action.expired,
        currentQuestionIndex: action.currentQuestionIndex,
        anonymityThreshold: action.anonymityThreshold,
      };
    case FETCH_SURVEY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case FETCH_SURVEY_RESULT_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SURVEY_RESULT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        results: action.results,
      };
    case FETCH_SURVEY_RESULT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case GOTO_NEXT_QUESTION:
      return {
        ...state,
        currentQuestionIndex: action.nextQuestionIndex,
      };
    case GOTO_PREV_QUESTION:
      return {
        ...state,
        currentQuestionIndex: action.prevQuestionIndex,
      };
    case SUBMIT_ANSWER_PENDING:
      return {
        ...state,
        isSaving: true,
        pendingAnswers: action.pendingAnswers || 0,
      };
    case SUBMIT_SURVEY_PENDING:
      return {
        ...state,
        isSubmitting: true,
        pendingAnswers: action.pendingAnswers || 0,
      };
    case SUBMIT_ANSWER_SUCCESS:
    case SUBMIT_ANSWER_FAIL:
      // Each time an answer submit succeeds or fails, decrement
      // the `pendingAnswers` by 1, but don't go below 0.
      pendingAnswers = state.pendingAnswers > 0 ? state.pendingAnswers - 1 : 0;

      return {
        ...state,
        isSaving: pendingAnswers > 0,
        pendingAnswers,
      };
    case SUBMIT_SURVEY_SUCCESS:
      return {
        ...state,
        isSaving: false,
        isSubmitting: false,
        isSubmitted: true,
      };
    case SUBMIT_SURVEY_FAIL:
      return {
        ...state,
        isSaving: false,
        isSubmitting: false,
        isSubmitted: false,
        submitError: action.error,
        isExpired: action.expired,
      };
    case RESET_APP:
      return defaultState;
    default:
      return state;
  }
};

export default surveyReducer;
